module.exports = __webpack_public_path__ + "img/government_motorway.05d6e72b.svg";